'use client'

import type { MenuItem } from '@graftcode/design-system'
import { Icon, IconComponent } from '@graftcode/design-system'

import { HELP_DRAWER_TEST_IDS } from '@common/common-test-ids.const'

import { ITEMS_WITH_SUB_FLOW } from '../../help-drawer.const'
import { isFluentIconValue } from '../../utils'

import styles from '../../HelpDrawer.module.scss'

type Props = {
  title: string
  sections: MenuItem[][]
  isHidden: boolean
  onItemClick: (itemId: string, active?: boolean) => void
}

export function HelpDrawerMenuView({ title, sections, isHidden, onItemClick }: Props) {
  return (
    <div className={styles.view} data-testid={HELP_DRAWER_TEST_IDS.menuView} aria-hidden={isHidden}>
      <div className={styles.viewHeader}>
        <p className={styles.viewTitle}>{title}</p>
        <div className={styles.headerDivider} />
      </div>

      {sections.map((section, sectionIndex) => (
        <div
          key={section[0]?.id ?? `section-${sectionIndex}`}
          className={`${styles.section} ${sectionIndex > 0 ? styles.sectionWithBorder : ''}`}
        >
          {section.map((item) => {
            const showChevron = ITEMS_WITH_SUB_FLOW.has(item.id)
            const isDisabled = item.active === false

            return (
              <button
                key={item.id}
                type="button"
                className={`${styles.item} ${isDisabled ? styles.disabled : ''}`}
                onClick={() => onItemClick(item.id, item.active)}
                disabled={isDisabled}
                tabIndex={isHidden ? -1 : 0}
              >
                {isFluentIconValue(item.icon) ? (
                  <IconComponent icon={item.icon} size={24} className={styles.itemIcon} />
                ) : (
                  <span className={styles.itemIcon}>{item.icon}</span>
                )}
                <span className={styles.itemLabel}>{item.label}</span>
                {showChevron && (
                  <IconComponent icon={Icon.ChevronRightRegular} size={20} className={styles.itemChevron} />
                )}
              </button>
            )
          })}
        </div>
      ))}
    </div>
  )
}
